import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { GridCellParams } from '@mui/x-data-grid-pro';
import { Box, Typography } from '@mui/material';
import { missingField } from 'app/constants';
import { navigationProfilesAction } from '@AMIEWEB/GlobalSearch/store/NavigationProfiles.redux';
import { useDispatch } from 'react-redux';

type IdField = 'placementId' | 'facilityId';

const PATH_MAP: Record<IdField, string> = {
  placementId: '/placement/',
  facilityId: '/facility/',
};

export const PlacementFacilityLinkCell = (field: IdField) => (params: GridCellParams) => {
  const dispatch = useDispatch();
  const row = params?.row ?? {};
  const id =
    field === 'placementId'
      ? row.placementId ?? row.placementID ?? null
      : row.facilityId ?? row.facilityID ?? null;
  const displayValue = id != null ? id : missingField;
  const path = PATH_MAP[field] + (id ?? '');

  const handleClick = () => {
    dispatch(navigationProfilesAction.setNavigationFlag({ navigationFromGrid: true }));
    dispatch(navigationProfilesAction.setCurrentRowId({ rowId: params?.row?.id }));
  };

  if (id == null) {
    return (
      <Typography component="span" sx={{ color: 'text.secondary', fontSize: 14 }}>
        {missingField}
      </Typography>
    );
  }

  return (
    <Box
      component={RouterLink}
      to={path}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: 'primary.main',
        textDecoration: 'none',
        fontSize: 14,
        '&:hover': { color: 'primary.dark', textDecoration: 'underline' },
      }}
    >
      {displayValue}
    </Box>
  );
};
